export const smoothScrollto = {

    init($) {
        this.catchHash();

        if ($('a[href^="#"]:not([href="#"])').length > 0) {
            $('a[href^="#"]:not([href="#"])').on('click', (e) => {
                e.preventDefault();
                let anchor = $(e.currentTarget).attr('href').replace('#', '');

                if (anchor.length > 0) {
                    const $scrollToElm = this.findTargetElement($, anchor);
                    this.scrollToElement($, $scrollToElm);
                }
            });
        }
    },

    catchHash() {
        if (window.location.hash) window.scrollTo(0, 0);

        // void some browsers issue
        setTimeout(() => { scroll(0, 0); }, 1);
    },

    findTargetElement($, anchor) {
        let $scrollToElm = $('a[name="' + anchor + '"]');
        if ($scrollToElm.length === 0) {
            $scrollToElm = $('#' + anchor);
        }
        return $scrollToElm;
    },

    scrollToElement($, $scrollToElm) {
        if ($scrollToElm.length > 0) {
            let scrollMarginTop = $scrollToElm.css('scrollMarginTop');
            if (!scrollMarginTop || scrollMarginTop === '0px') scrollMarginTop = '60px';
            scrollMarginTop = parseInt(scrollMarginTop.replace('px', ''), 10);

            const scrollTo = $scrollToElm.offset().top - (scrollMarginTop + 170);

            $('html, body').stop().animate({
                scrollTop: scrollTo
            }, 900, 'swing');
        }
    }
};
